import months from './months'

const currentStatitics = (statistics) => {
  const monthNow = new Date()
  let statisticsCurrent = statistics.filter(function (items) {
    return items.schedule_month === monthNow.getMonth() + 1
  })

  return statisticsCurrent
}

export default {
  afterPrepareShow () {
    if (currentStatitics(this.statistics)) {
      this.statistics = currentStatitics(this.statistics)
      if (this.statistics.length > 0) {
        this.currentMonth = months(this.statistics)
        this.scheduleYear = this.statistics[0].schedule_year
        if (this.statistics[0].events_by_speciality) {
          this.ishidden = true
        }
        this.total = currentStatitics(this.statistics).reduce((acc, item) => {
          let totalEvent = acc + item.events_by_speciality
          if (totalEvent === '000') {
            return '0'
          } else {
            return totalEvent
          }
        }, 0)
      }
    }
  },
  prepareShow (speciality) {
    speciality.speciality = speciality.name

    return speciality
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/abstract-speciality/resources/methods.js